import React from 'react';
import { usePlaylistArtwork } from '../../hooks/usePlaylistArtwork';

const PlaylistTile = ({ playlist, onClick }) => {
  const { artworkUrls, isLoading } = usePlaylistArtwork(playlist);

  const renderArtwork = () => {
    if (isLoading) {
      return <div className="w-full h-full bg-gray-200 animate-pulse"></div>;
    }

    if (artworkUrls.length === 4) {
      return (
        <div className="grid grid-cols-2 grid-rows-2 h-full w-full">
          {artworkUrls.map((url, index) => (
            <img 
              key={index} 
              src={url} 
              alt={`Playlist artwork ${index + 1}`} 
              className="w-full h-full object-cover"
            />
          ))}
        </div>
      );
    }

    return (
      <img 
        src={artworkUrls[0]} 
        alt={playlist.name}
        className="w-full h-full object-cover"
      />
    );
  };

  return (
    <div
      onClick={onClick}
      className="aspect-square rounded-lg overflow-hidden shadow-lg relative cursor-pointer group"
    >
      {renderArtwork()}
      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-all duration-300"></div>
      <p className="absolute bottom-2 left-2 right-2 text-white text-lg font-bold drop-shadow-md truncate">
        {playlist.name}
      </p>
    </div>
  );
};

export default PlaylistTile;
